import { gql } from "../__generated__";

export const GetGroupById = gql(`
  query GetGroupById(
    $where: GruppeWhereUniqueInput!
    $hydrateRelationships: Boolean!
  ) {
    group: gruppe(where: $where) {
      id
      bezeichnung
      description {
        document(hydrateRelationships: $hydrateRelationships)
      }
      otherTitles {
        document(hydrateRelationships: $hydrateRelationships)
      }
      images {
        images {
          bild {
            url
            id
          }
          objekte {
            title
            id
            description {
              document(
                hydrateRelationships: $hydrateRelationships
              )
            }
            copyright {
              name
            }
            images {
              title
              name
            }
            periodOfOrigin {
              displayName
            }
            authorPerson {
              familyName
              givenName
              id
            }
            authorGroup {
              id
              bezeichnung
            }
            personsOnWork {
              familyName
              givenName
              id
            }
            groupsOnWork {
              id
              bezeichnung
            }
            locationOnWork {
              id
              name
            }
          }
        }
      }
      typen {
        name
      }
      characters {
        familyName
        givenName
        id
      }
      places {
        name
        id
      }
      partOf {
        bezeichnung
        id
      }
      objectAuthor {
        id
        title
      }
      contains {
        id
        bezeichnung
      }
      owner {
        id
        displayName
      }
      onEvents {
        title
        id
      }
      periodOfOrigin {
        displayName
      }
      weblinks {
        document
      }
    }
  }
`);
